const messages = {
    pageTitle: 'Konfiguracje / Narzędzia',
    menuTitle: 'Narzędzia',
    common: {
        tooltips: {
            edit: 'Edytuj',
            delete: 'Usuń'
        }
    },
    dieCutters: {
        pages: {
            main: {
                sections: {
                    title: 'Lista wykrojników',
                    actions: {
                        addDmt: 'Nowy wykrojnik DMT',
                        addCf: 'Nowy wykrojnik CF'
                    },
                    filters: {
                        searchPlaceholder: 'Symbol...'
                    },
                    table: {
                        columns: {
                            symbol: 'Symbol wykrojnika',
                            productType: 'Produkt',
                            format: 'Format',
                            actions: 'Akcje'
                        }
                    }
                },
                confirmDelete: {
                    title: 'Usuwanie wykrojnika',
                    content: 'Czy na pewno chcesz usunąć wykrojnik {symbol}?',
                    confirm: 'Usuń',
                    abort: 'Anuluj'
                },
                dialog: {
                    titles: {
                        create: 'Tworzenie wykrojnika',
                        edit: 'Edycja wykrojnika {symbol}'
                    },
                    fields: {
                        type: 'Rodzaj wykrojnika',
                        productTypeId: 'Rodzaj produktu',
                        format: 'Format produktu',
                        symbol: 'Symbol',
                        price: 'Cena wykrojnika',
                        sheetFormatId: 'Format arkusza',
                        parts: 'Ilość użytków',
                        machineId: 'Maszyna',
                        rack: 'Regał',
                        shelf: 'Półka',
                        file: 'Plik wykrojnika'
                    },
                    file: {
                        selectPlaceholder: 'Wybierz plik',
                        upload: 'Wyślij',
                        download: 'Pobierz',
                        remove: 'Usuń',
                        cancel: 'Anuluj wysyłanie',
                        noFile: 'Nie dodano pliku dla wykrojnika.'
                    },
                    actions: {
                        cancel: 'Anuluj',
                        save: 'Zapisz'
                    },
                    messages: {
                        uploadInProgress: 'Wysyłanie...'
                    },
                    errors: {
                        productTypeRequired: 'Proszę wybrać rodzaj produktu.',
                        formatRequired: 'Proszę podać format produktu.',
                        symbolRequired: 'Proszę podać symbol wykrojnika.',
                        shelfRequired: 'Proszę wybrać półkę.',
                        fileTooLarge: 'Przekroczono dopuszczalny rozmiar pliku: {size} MB.'
                    }
                }
            }
        },
        notifications: {
            saved: 'Wykrojnik został zapisany.',
            deleted: 'Wykrojnik został usunięty.',
            fileUploaded: 'Plik wykrojnika został dodany.',
            fileDeleted: 'Plik wykrojnika został usunięty.'
        },
        errors: {
            fetchList: 'Pobranie listy wykrojników nie powiodło się.',
            fetchOne: 'Pobranie wykrojnika nie powiodło się.',
            save: 'Zapisanie wykrojnika nie powiodło się.',
            delete: 'Usunięcie wykrojnika nie powiodło się.',
            upload: 'Przesłanie pliku nie powiodło się.',
            deleteFile: 'Usunięcie pliku nie powiodło się.',
            fetchProductTypes: 'Pobranie listy produktów nie powiodło się.',
            fetchMachineSheetFormats: 'Pobranie formatów arkuszy nie powiodło się.',
            fetchMachines: 'Pobranie maszyn nie powiodło się.',
            fetchRacks: 'Pobranie regałów nie powiodło się.',
            fetchShelves: 'Pobranie półek nie powiodło się.'
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
